export const environment = {
  production: false,
  apiHost: "https://api-hml.smartapp.razek.com.br", // Razek AWS
  graphQL: "https://api-hml.smartapp.razek.com.br/recommendation/graphql",
  recommendationApi: "https://api-hml.smartapp.razek.com.br/recommendation/api",
};
